import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">EmergData · Your Data, Simplified</p>
        <h1>Empower Your Decisions with Data.</h1>
        <p className="lede">
          At EmergData, we specialize in transforming your data into a strategic asset. 
          Discover our user-friendly tools designed to enhance your data management and drive impactful results.
        </p>
        <div className="cta-row">
          <a href="https://docs.emergendata.com" target="_blank">
            Discover How
          </a>
          <a href="https://github.com/emergendata" target="_blank" className="secondary">
            View Our Solutions
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Optimize Your Processes</h2>
          <p>
            Our platform streamlines data management, enabling you to concentrate on making data-driven decisions.
          </p>
        </article>
        <article>
          <h2>Unlock Insights Instantly</h2>
          <p>
            Convert your data into meaningful insights with our intuitive analytics tools, customized for your goals.
          </p>
        </article>
        <article>
          <h2>Data Security You Can Trust</h2>
          <p>
            Rely on our comprehensive security protocols to protect your data while maximizing its potential.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;